module.exports = __webpack_public_path__ + "static/img/pro4_tab1.af7d81d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro4_tab1.jpg
// module id = Vqfv
// module chunks = 171